// Hook personalizado que gestiona la sincronización con Firebase.
// Solo expone la canción EMITIDA (la que Firebase tiene activa).
// La lógica de previsualización local vive en App.js.
import { useState, useEffect } from "react";
import { escucharCancionActiva, cambiarCancionActiva } from "../firebase";

export function useCancionSincronizada() {
  const [cancionEmitida, setCancionEmitida] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const unsubscribe = escucharCancionActiva((datos) => {
      setCancionEmitida(datos);
      setCargando(false);
    });
    return () => unsubscribe();
  }, []);

  // Emite la canción a Firebase → la ven todos los dispositivos
  const emitirCancion = async (cancion) => {
    await cambiarCancionActiva(cancion);
  };

  // Borra la emisión → pantalla en blanco en todos los dispositivos
  const limpiarEmision = async () => {
    await cambiarCancionActiva(null);
  };

  return { cancionEmitida, cargando, emitirCancion, limpiarEmision };
}
